import React from 'react';
//import { withRouter } from 'react-router';
import { withApollo, graphql } from "react-apollo";

import { formatDate } from '../../util';
import { note } from '../../graphql/queries';
import { ColHead, ColError, ColLoading } from '../chunk';
import { NoteTextarea, NoteDelete } from "./index";

class NoteDetail extends React.Component {
	
	render() {

		let { loading, error, note } = this.props.data;		
		
		if( loading ) return (<div className="col col-2"><ColLoading /></div>)
		if( error ) return (<div className="col col-2"><ColError error={error} /></div>)

    	const dateCreated = formatDate(note.dateCreated);

		return (
      		<div className="col col-2" key={note.id}>
              <div className="col__actions">
                <NoteDelete id={note.id} />
              </div>
      			<ColHead icon="sticky-note" title="NOTE DETAIL" meta={dateCreated} />
            	<NoteTextarea id={note.id} body={note.body} />
      		</div>
      	)
	}
}

const queryOptions = {
  options: props => ({
    variables: { id: props.match.params.id }
  })
}

export default withApollo(graphql(note, queryOptions)(NoteDetail))


// WEBPACK FOOTER //
// ./src/components/note/NoteDetail.js